export default {"src":"/_next/static/media/footer-blue-mobile-bg.6300ded0.svg","height":406,"width":375,"blurWidth":0,"blurHeight":0};